module.exports = __webpack_public_path__ + "img/zw.2f56df10.svg";